import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CourseService {
    private courseData;
    private courseId : string;

    constructor(private http: HttpClient) { }
    
    saveCourseData(courseId, courseData) {
        this.courseId = courseId;
        this.courseData = courseData;
    }

    getCourseData(): any {
        return {
            courseId: this.courseId,
            courseData: this.courseData
        }
    }
    
    enroll(courseId) {

        this.http.post(`${environment.apiUrl}/api/course/enroll/${courseId}`, {}).subscribe(o => {
            console.log(o);
        });

        this.http.post(`${environment.apiUrl}/api/course/save/${courseId}`, {}).subscribe(o => {
            console.log(o);
        });
    }
       
    recordProgress(courseId, state) {

        console.log("Record Progress", { courseId: courseId, state: state });

        this.http.post(`${environment.apiUrl}/api/course/save/${courseId}`, 
        {            
            state: state
        }).subscribe(o => {
            console.log(o);
        });
    }

    loadProgress(courseId) : Observable<any> {
        return this.http.get(`${environment.apiUrl}/api/user/course/${courseId}`, {});
    }   
}